module.exports = "data:image/gif;base64,R0lGODlhCQAPALMNAEVFRf///6urq93d3e3t7aOjo7S0tPLy8rq6utHR0aWlpcPDw8XFxf///wAAAAAAACH5BAEAAA0ALAAAAAAJAA8AAAQ1sMlJq7VDaKVKWUIgigcBhGPJnCkxIIASADQNF0E5DIkBFDoew1cgJBgIgxKwqDkXl6h0EgEAOw=="


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/grid/group-collapse.gif
 ** module id = 276
 ** module chunks = 0
 **/